<template>
  <div class="cheer_wrap">
    <div class="inner">
      <h1 class="tit_h1">2021 프로야구 응원 이벤트</h1>
      <div class="tit_tx">
        <p>우리팀 <em>응원</em>하고</p>
        <p>100% 당첨 선물받자!</p>
      </div>

      <dl>
        <dt>이벤트 기간 안내</dt>
        <dd>2021년 4월 23일(금) - 5월 31일(월)</dd>
      </dl>
      <dl>
        <dt>이벤트 대상</dt>
        <dd>2021년 4월 이전 가입자 전원</dd>
      </dl>
      <dl>
        <dt>이벤트 혜택</dt>
        <dd>
          <span>비에스에스 365 데일리 마스크 50매 1box</span>
          <span class="plus">+</span>
          <span>벳블 50,000 골드</span>
        </dd>
        <dd class="u">※ 마스크 상품 수령 안내는 이벤트 기간 내 순차적으로 쪽지로 발송됩니다.</dd>
      </dl>
      <dl>
        <dt>참여하기</dt>
        <dd>자신이 응원하는 팀의 응원메시지 입력후 이벤트 참여 클릭</dd>
      </dl>
      <div class="event">
        <div v-if="isDuplicate">
          <div class="complete">
            <span>이미 참여하셨습니다.</span>
            <span>(이벤트 참여는 1회만 가능합니다.)</span>
          </div>
        </div>
        <div v-else>
          <form>
            <input type="text" v-model="inputValue" placeholder="응원 메시지를 입력해주세요." />
            <button type="submit" @click="joinEvent">이벤트참여</button>
          </form>
        </div>
      </div>
      <div class="tip">※ 상품 소진시 이벤트는 조기 종료 될 수 있습니다.</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "cheer",
  data() {
    return {
      isDuplicate: window.isDuplicate,
      inputValue: ''
    }
  },
  methods: {
    async joinEvent(e) {
      e.preventDefault();
      if (!window.userInfo.level) {
        alert('로그인을 해주세요');
        location.href='/members/login.php?returnUrl=/event/cheer.php';
        return;
      }

      const cheerMessage = this.inputValue;
      if (!cheerMessage) {
        alert('메시지를 입력해주세요');
        return;
      }

      try {
        const { data } = await this._post('/v1/event/cheer', {
          cheerMessage
        });
        if (data.message) {
          alert(data.message);
        }

        if (data.code === 200) {
          this.inputValue = '';
          this.isDuplicate = true;
          conm.topuserinfo();
        }
      } catch (e) {
        alert('알 수 없는 오류가 발생했습니다. 다시 시도 해주세요');
        console.error('joinEvent', e);
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/event/cheer.vue